type DashboardSession = {
  id: number;
  plannedStart: string;
  status: "entwurf" | "geplant" | "abgeschlossen" | "storniert";
};

export function getDashboardWorkSummary<T extends DashboardSession>(sessions: T[], now = new Date()) {
  const nowMs = now.getTime();
  const nextSevenDaysLimit = nowMs + 7 * 24 * 60 * 60 * 1000;
  const upcoming = sessions
    .filter((session) => (session.status === "geplant" || session.status === "entwurf") && new Date(session.plannedStart).getTime() >= nowMs)
    .sort((a, b) => a.plannedStart.localeCompare(b.plannedStart));

  return {
    nextSevenDays: upcoming.filter((session) => session.status === "geplant" && new Date(session.plannedStart).getTime() < nextSevenDaysLimit).length,
    drafts: sessions.filter((session) => session.status === "entwurf").length,
    upcoming,
  };
}
